import React from "react";
import { string, object, func } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";

import Headline from "../Headline";

import { setDateParams } from "../../helper/actions";

import "./bigSectionName.m.css";

const BigSectionName = ({ domainSlug, sectionsDataForHeader, domainSectionObj, src, language, setDateParams }) => {
  if (!sectionsDataForHeader) {
    return null;
  }

  const getSetionData = () => {
    if (
      (domainSlug && sectionsDataForHeader.parentSectionId !== domainSectionObj.id) ||
      (sectionsDataForHeader.parentSection && !domainSlug)
    ) {
      return {
        sectionName: sectionsDataForHeader.parentSection,
        sectionUrl: sectionsDataForHeader.parentSectionUrl,
      };
    }

    return {
      sectionName: sectionsDataForHeader.currentSection,
      sectionUrl: sectionsDataForHeader.currentSectionUrl,
    };
  };

  return (
    <li className="section" styleName="section-name-container">
      <Link href={getSetionData().sectionUrl}>
        {src === "section" ? (
          <Headline
            onClick={() => setDateParams("")}
            headerLevel={1}
            headlineType={9}
            text={getSetionData().sectionName}
            styleName={`${language}-section-name`}
          />
        ) : (
          getSetionData().sectionName
        )}
      </Link>
    </li>
  );
};

BigSectionName.propTypes = {
  domainSlug: string,
  domainSectionObj: object,
  sectionsDataForHeader: object,
  src: string,
  language: string,
  setDateParams: func,
};

const mapDispatchToProps = (dispatch) => ({
  setDateParams: (date) => dispatch(setDateParams(date)),
});

export default connect(null, mapDispatchToProps)(BigSectionName);
